import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { Theme } from 'styles/ThemeTyping';

import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Popper from '@material-ui/core/Popper';

interface Props {
  anchorEl: null | HTMLElement;
  menuItems: Array<{ id: string; displayName: string }>;
  placeholderText?: string;
  onSubmit: (selectedIds: Array<string>) => void;
  onClose: () => void;
}

function EditMembersDropdown({
  anchorEl,
  menuItems,
  placeholderText = 'Type to search',
  onSubmit,
  onClose,
}: Props) {
  const classes = useStyles();
  const [searchInput, setSearchInput] = useState('');
  const [searchedItems, setSearchedItems] = useState(menuItems);
  const [selectedItemIds, setSelectedItemIds] = useState<Array<string>>([]);

  useEffect(() => {
    setSearchedItems(menuItems);
  }, [menuItems]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchInput(value);
    const filteredItems = menuItems.filter(item =>
      item.displayName.toLowerCase().includes(value.toLowerCase()),
    );
    setSearchedItems(filteredItems);
  };

  const handleSelectItem = (itemId: string) => {
    setSelectedItemIds(prevSelectedIds => {
      if (prevSelectedIds.includes(itemId)) {
        return prevSelectedIds.filter(id => id !== itemId);
      }
      return [...prevSelectedIds, itemId];
    });
  };

  const handleSelectAll = () => {
    const allIds = menuItems.map(item => item.id);
    setSelectedItemIds(allIds);
  };

  return (
    <Popper open={!!anchorEl} anchorEl={anchorEl} transition disablePortal>
      <Paper className={classes.root}>
        <div>
          <div className={classes.row}>
            <TextField
              onChange={handleSearch}
              fullWidth
              placeholder={placeholderText}
              value={searchInput}
            />
          </div>

          <MenuList className={classes.menu}>
            {searchedItems.map(item => (
              <MenuItem key={item.id} onClick={() => handleSelectItem(item.id)}>
                <Checkbox checked={selectedItemIds.includes(item.id)} />
                {item.displayName}
              </MenuItem>
            ))}
          </MenuList>
        </div>
        <div className={classes.actions}>
          <Button onClick={handleSelectAll}>Select All ({menuItems.length})</Button>

          <div className={classes.buttonContainer}>
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={() => onSubmit(selectedItemIds)} variant="contained" color="secondary">
              Remove
            </Button>
          </div>
        </div>
      </Paper>
    </Popper>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 363,
    padding: theme.spacing(),
  },
  menu: {
    overflowY: 'auto',
    maxHeight: 501,
  },
  row: {
    height: 32,
    paddingLeft: theme.spacing(),
  },
  actions: {
    display: 'flex',
  },
  buttonContainer: {
    marginLeft: 'auto',
    padding: theme.spacing(),
  },
}));

export default EditMembersDropdown;
